var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/document-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 14.2188H5C2.71875 14.2188 1.40625 12.9062 1.40625 10.625V4.375C1.40625 2.09375 2.71875 0.78125 5 0.78125H10C12.2812 0.78125 13.5938 2.09375 13.5938 4.375V10.625C13.5938 12.9062 12.2812 14.2188 10 14.2188ZM5 1.71875C3.2125 1.71875 2.34375 2.5875 2.34375 4.375V10.625C2.34375 12.4125 3.2125 13.2812 5 13.2812H10C11.7875 13.2812 12.6562 12.4125 12.6562 10.625V4.375C12.6562 2.5875 11.7875 1.71875 10 1.71875H5Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.5625 5.78125H10.3125C9.3625 5.78125 8.59375 5.0125 8.59375 4.0625V2.8125C8.59375 2.55625 8.80625 2.34375 9.0625 2.34375C9.31875 2.34375 9.53125 2.55625 9.53125 2.8125V4.0625C9.53125 4.49375 9.88125 4.84375 10.3125 4.84375H11.5625C11.8187 4.84375 12.0312 5.05625 12.0312 5.3125C12.0312 5.56875 11.8187 5.78125 11.5625 5.78125Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.5 8.59375H5C4.74375 8.59375 4.53125 8.38125 4.53125 8.125C4.53125 7.86875 4.74375 7.65625 5 7.65625H7.5C7.75625 7.65625 7.96875 7.86875 7.96875 8.125C7.96875 8.38125 7.75625 8.59375 7.5 8.59375Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 11.0938H5C4.74375 11.0938 4.53125 10.8813 4.53125 10.625C4.53125 10.3688 4.74375 10.1562 5 10.1562H10C10.2562 10.1562 10.4688 10.3688 10.4688 10.625C10.4688 10.8813 10.2562 11.0938 10 11.0938Z",
    fill: "#012169"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTextIcon);
export default __webpack_public_path__ + "static/media/documentTextIcon.1aa3db28bee9e75fc5d79841300ed9f6.svg";
export { ForwardRef as ReactComponent };